/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

export default function DomainLayout() {
  return (
    <div>
      <div>
        <h2 className="helpHeaderTitle">Select Domain </h2>
        <div className="helpContentSection">
          {" "}
          <div className="imageRow mb-3">
            <div className="imageSection">
              {" "}
              <img
                alt=""
                src={require("../../assets/images/helpCenter/domainCenterImg1.png")}
              />
            </div>
            <div className="imageInfoSection">
              <div className="boldTitle">Find Domain Page</div>
              <div>
                Click the user image in the top right of the page and select
                “Domains.”
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Select Domain</div>
            <div>
              From this page click into the desired domain. This is where all
              the screens and content for the desired networks reside.
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/domainCenterImg2.png")}
          />
        </div>
      </div>
    </div>
  );
}
